import numeral from 'numeral';
import { func } from 'prop-types';

String.prototype.capitalizeFirstLetter = function () {
  return this.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1)
  );
};

String.prototype.capitalize = function () {
  return this.replace(
    /\w\S*/,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
};

String.prototype.isJSON = function () {
  try {
    JSON.parse(this);
    return true;
  } catch {
    return false;
  }
};

String.prototype.isEmail = function () {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(this.toLowerCase());
};

String.prototype.toReadableUrl = function () {
  return this.replace(' ', '-').toLowerCase();
};

String.prototype.toNormalString = function () {
  return this.replace('-', ' ').toLowerCase();
};

Number.prototype.toReadable = function () {
  return numeral(this).format('0,00.0');
};

export function tooltipText(value, options) {
  if (value == null) {
    return 'No description available';
  }
  const selectedOption = options.find(
    (opt) => Number(opt.value) === Number(value)
  );
  return selectedOption ? selectedOption.label : 'No description available';
}
